import { Modal, Button } from 'antd';

interface KpiDeleteConfirmationModalProps {
  open: boolean;
  handleCloseDelete: () => void;
  handleDelete: () => void;
  deleteMessage: string;
  loading?: boolean;
}

const KpiDeleteConfirmationModal = (props: KpiDeleteConfirmationModalProps) => {
  const { open, handleCloseDelete, handleDelete, deleteMessage, loading = false } = props;

  return (
    <Modal
      title="Delete Confirmation"
      centered
      open={open}
      footer={null}
      maskClosable={false}
      onCancel={handleCloseDelete}
    >
      <div className='pt-4'>{deleteMessage}</div>
      <div className='mt-5 flex justify-end gap-3'>
        <button
          className='addButton secondary'
          onClick={handleCloseDelete}
        >
          Cancel
        </button>
        <Button
          className='addButton'
          onClick={() => {
            handleDelete();
          }}
          loading={loading}
          type="primary"
          style={{ background: '#d34a7c', borderColor: '#d34a7c' }}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default KpiDeleteConfirmationModal;
